
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import {
  fetchPendingOnboarding,
  completeOnboarding,
  deletePendingRegistration,
  setSelectedEmployee,
  clearSelectedEmployee,
  setSearchTerm,
  clearSuccessMessage,
  clearPendingError,
  clearCompleteStatus,
  clearAllOnboarding
} from '../../../redux/slices/onboardingSlice';

const AdminRegisterEmployee = () => {
  const dispatch = useDispatch();
  
  // Redux state
  const {
    pendingEmployees,
    pendingLoading,
    pendingError,
    completeLoading,
    completeError,
    selectedEmployee,
    searchTerm,
    successMessage,
  } = useSelector((state) => state.onboarding);

  // Local state for HR form
  const [employeeForm, setEmployeeForm] = useState({
    department: "",
    designation: "",
    employeeType: "full-time",
    dateOfJoining: new Date().toISOString().split('T')[0],
    employmentStatus: "Active",
    reportingManager: "",
    workLocation: "",
    shiftTiming: "9:00 AM - 6:00 PM",
    probationPeriod: "3",
    // basicSalary: "",
    // allowance: "",
    // deduction: "",
    // bankName: "",
    // accountNumber: "",
    // ifscCode: "",
    // hrNotes: "",
    role: "employee",
    permissions: ["view_own_attendance"],
  });

  // Load pending registrations on component mount
  useEffect(() => {
    dispatch(fetchPendingOnboarding());
  }, [dispatch]);

  // Show success message toast
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(clearSuccessMessage());
    }
  }, [successMessage, dispatch]);

  // Show error toast
  useEffect(() => {
    if (pendingError) {
      toast.error(pendingError);
    }
    if (completeError) {
      toast.error(completeError);
    }
  }, [pendingError, completeError]);

  // Auto calculate net salary
  // useEffect(() => {
  //   const basic = Number(employeeForm.basicSalary || 0);
  //   const allowance = Number(employeeForm.allowance || 0);
  //   const deduction = Number(employeeForm.deduction || 0);
  //   setEmployeeForm(prev => ({
  //     ...prev,
  //     netSalary: (basic + allowance - deduction).toString()
  //   }));
  // }, [employeeForm.basicSalary, employeeForm.allowance, employeeForm.deduction]);

  // Handle employee selection from pending list
  const handleEmployeeSelect = (employee) => {
    dispatch(setSelectedEmployee(employee));
    
    // Auto-fill HR form with default values
    setEmployeeForm({
      department: employee.department || "",
      designation: employee.designation || "",
      employeeType: employee.employeeType || "full-time",
      dateOfJoining: employee.dateOfJoining 
        ? new Date(employee.dateOfJoining).toISOString().split('T')[0] 
        : new Date().toISOString().split('T')[0],
      employmentStatus: "Active",
      reportingManager: "",
      workLocation: employee.address || "",
      shiftTiming: "9:00 AM - 6:00 PM",
      probationPeriod: "3",
      // basicSalary: "",
      // allowance: "",
      // deduction: "",
      // bankName: employee.bankName || "",
      // accountNumber: employee.accountNumber || "",
      // ifscCode: employee.ifscCode || "",
      // hrNotes: "",
      role: employee.role || "employee",
      permissions: employee.permissions || ["view_own_attendance"],
    });
  };

  // Handle HR form changes
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setEmployeeForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle complete onboarding
  // const handleCompleteOnboarding = async () => {
  //   if (!selectedEmployee) {
  //     toast.error("Please select an employee first!");
  //     return;
  //   }

  //   // Validation
  //   if (!employeeForm.department || !employeeForm.designation || !employeeForm.dateOfJoining) {
  //     toast.error("Please fill all required fields: Department, Designation, and Date of Joining");
  //     return;
  //   }

  //   // Prepare employee data
  //   const employeeData = {
  //     department: employeeForm.department,
  //     designation: employeeForm.designation,
  //     employeeType: employeeForm.employeeType,
  //     dateOfJoining: employeeForm.dateOfJoining,
  //     role: employeeForm.role,
  //     permissions: employeeForm.permissions,
  //     workLocation: employeeForm.workLocation,
  //     shiftTiming: employeeForm.shiftTiming,
  //     probationPeriod: employeeForm.probationPeriod,
  //     basicSalary: employeeForm.basicSalary,
  //     allowance: employeeForm.allowance,
  //     deduction: employeeForm.deduction,
  //     bankName: employeeForm.bankName,
  //     accountNumber: employeeForm.accountNumber,
  //     ifscCode: employeeForm.ifscCode,
  //     hrNotes: employeeForm.hrNotes,
  //     isActive: true,
  //     onboardingStatus: "completed"
  //   };

  //   // Dispatch complete onboarding action
  //   dispatch(completeOnboarding({
  //     employeeId: selectedEmployee._id,
  //     employeeData
  //   }))
  //   .then(() => {
  //     // Reset form after successful completion
  //     setEmployeeForm({
  //       department: "",
  //       designation: "",
  //       employeeType: "full-time",
  //       dateOfJoining: new Date().toISOString().split('T')[0],
  //       employmentStatus: "Active",
  //       reportingManager: "",
  //       workLocation: "",
  //       shiftTiming: "9:00 AM - 6:00 PM",
  //       probationPeriod: "3",
  //       basicSalary: "",
  //       allowance: "",
  //       deduction: "",
  //       bankName: "",
  //       accountNumber: "",
  //       ifscCode: "",
  //       hrNotes: "",
  //       role: "employee",
  //       permissions: ["view_own_attendance"],
  //     });
  //   });
  // };


  // handleCompleteOnboarding function में employeeData update करें:
// const handleCompleteOnboarding = async () => {
//   if (!selectedEmployee) {
//     toast.error("Please select an employee first!");
//     return;
//   }

//   // Validation
//   if (!employeeForm.department || !employeeForm.designation || !employeeForm.dateOfJoining) {
//     toast.error("Please fill all required fields: Department, Designation, and Date of Joining");
//     return;
//   }

//   // ✅ Generate employee ID on frontend या backend पर छोड़ दें
//   // Prepare employee data - सभी required fields शामिल करें
//   const employeeData = {
//     // Basic Info
//     department: employeeForm.department,
//     designation: employeeForm.designation,
//     employeeType: employeeForm.employeeType,
//     dateOfJoining: employeeForm.dateOfJoining,
    
//     // Role & Permissions
//     role: employeeForm.role,
//     permissions: employeeForm.permissions,
    
//     // Work Details
//     workLocation: employeeForm.workLocation,
//     shiftTiming: employeeForm.shiftTiming,
//     probationPeriod: employeeForm.probationPeriod,
    
//     // Salary Details
//     basicSalary: employeeForm.basicSalary || "0",
//     allowance: employeeForm.allowance || "0",
//     deduction: employeeForm.deduction || "0",
    
//     // Bank Details
//     bankName: employeeForm.bankName || selectedEmployee.bankName || "",
//     accountNumber: employeeForm.accountNumber || selectedEmployee.accountNumber || "",
//     ifscCode: employeeForm.ifscCode || selectedEmployee.ifscCode || "",
    
//     // HR Notes
//     hrNotes: employeeForm.hrNotes,
    
//     // Status
//     isActive: true,
//     onboardingStatus: "completed"
//   };

//   // Debugging के लिए
//   console.log("Sending data to backend:", {
//     employeeId: selectedEmployee._id,
//     employeeData
//   });

//   // Dispatch complete onboarding action
//   dispatch(completeOnboarding({
//     employeeId: selectedEmployee._id,
//     employeeData
//   }))
//   .then((result) => {
//     if (result.meta.requestStatus === 'fulfilled') {
//       // Reset form after successful completion
//       setEmployeeForm({
//         department: "",
//         designation: "",
//         employeeType: "full-time",
//         dateOfJoining: new Date().toISOString().split('T')[0],
//         employmentStatus: "Active",
//         reportingManager: "",
//         workLocation: "",
//         shiftTiming: "9:00 AM - 6:00 PM",
//         probationPeriod: "3",
//         basicSalary: "",
//         allowance: "",
//         deduction: "",
//         bankName: "",
//         accountNumber: "",
//         ifscCode: "",
//         hrNotes: "",
//         role: "employee",
//         permissions: ["view_own_attendance"],
//       });
//     }
//   });
// };


// AdminRegisterEmployee.js में ये line change करें:
// const handleCompleteOnboarding = async () => {
//   // ... existing code ...
  
//   // ✅ सही API endpoint use करें
//   dispatch(completeOnboarding({
//     employeeId: selectedEmployee._id,  // ये सही ID है
//     employeeData: employeeData
//   }))
//   .then((result) => {
//     if (result.meta.requestStatus === 'fulfilled') {
//       // Success
//     } else {
//       // Error - check console for details
//       console.error("Onboarding failed:", result.error);
//     }
//   });
// };

// handleCompleteOnboarding function को ये COMPLETE CODE से replace करें:

// const handleCompleteOnboarding = async () => {
//   if (!selectedEmployee) {
//     toast.error("Please select an employee first!");
//     return;
//   }

//   // ✅ REQUIRED FIELDS VALIDATION
//   const requiredFields = [
//     { field: 'department', label: 'Department' },
//     { field: 'designation', label: 'Designation' },
//     { field: 'dateOfJoining', label: 'Date of Joining' }
//   ];

//   const missingFields = requiredFields
//     .filter(item => !employeeForm[item.field])
//     .map(item => item.label);

//   if (missingFields.length > 0) {
//     toast.error(`Required: ${missingFields.join(', ')}`);
//     return;
//   }

//   try {
//     // ✅ PREPARE DATA FOR BACKEND
//     const employeeData = {
//       // Required fields
//       department: employeeForm.department,
//       designation: employeeForm.designation,
//       dateOfJoining: employeeForm.dateOfJoining,
      
//       // Optional with defaults
//       employeeType: employeeForm.employeeType || "full-time",
//       workLocation: employeeForm.workLocation || "",
//       shiftTiming: employeeForm.shiftTiming || "9:00 AM - 6:00 PM",
//       probationPeriod: employeeForm.probationPeriod || "3",
//       basicSalary: employeeForm.basicSalary || "0",
//       allowance: employeeForm.allowance || "0",
//       deduction: employeeForm.deduction || "0",
//       role: employeeForm.role || "employee",
//       permissions: employeeForm.permissions || ["view_own_attendance"],
//       hrNotes: employeeForm.hrNotes || "",
      
//       // For fallback lookup
//       email: selectedEmployee.email,
//       mobile: selectedEmployee.mobile
//     };

//     console.log("📤 Sending to backend:", {
//       employeeId: selectedEmployee._id,
//       data: employeeData
//     });

//     // ✅ DISPATCH ACTION
//     const result = await dispatch(completeOnboarding({
//       employeeId: selectedEmployee._id,
//       employeeData
//     })).unwrap();

//     // Success
//     toast.success(result.message);
    
//     // ✅ RESET FORM
//     setEmployeeForm({
//       department: "",
//       designation: "",
//       employeeType: "full-time",
//       dateOfJoining: new Date().toISOString().split('T')[0],
//       employmentStatus: "Active",
//       reportingManager: "",
//       workLocation: "",
//       shiftTiming: "9:00 AM - 6:00 PM",
//       probationPeriod: "3",
//       basicSalary: "",
//       allowance: "",
//       deduction: "",
//       bankName: "",
//       accountNumber: "",
//       ifscCode: "",
//       hrNotes: "",
//       role: "employee",
//       permissions: ["view_own_attendance"],
//     });

//   } catch (error) {
//     console.error("❌ Onboarding error:", error);
//     toast.error(error || "Failed to complete onboarding");
//   }
// };


const handleCompleteOnboarding = async () => {
  // 1. Basic check
  if (!selectedEmployee) {
    toast.error("Please select an employee first!");
    return;
  }

  // 2. Validation
  if (!employeeForm.department || !employeeForm.designation || !employeeForm.dateOfJoining) {
    toast.error("Please fill: Department, Designation, Date of Joining");
    return;
  }

  // 3. Simple data
  const employeeData = {
    department: employeeForm.department,
    designation: employeeForm.designation,
    dateOfJoining: employeeForm.dateOfJoining,
    role: employeeForm.role || "employee",
    email: selectedEmployee.email,
    mobile: selectedEmployee.mobile,
  };

  console.log("📤 Sending:", employeeData);

  try {
    const result = await dispatch(completeOnboarding({
      employeeId: selectedEmployee._id,
      employeeData
    })).unwrap();

    toast.success(result.message);
    
    // Reset form
    setEmployeeForm({
      department: "",
      designation: "",
      employeeType: "full-time",
      dateOfJoining: new Date().toISOString().split('T')[0],
      employmentStatus: "Active",
      reportingManager: "",
      workLocation: "",
      shiftTiming: "9:00 AM - 6:00 PM",
      probationPeriod: "3",
      // basicSalary: "",
      // allowance: "",
      // deduction: "",
      // bankName: "",
      // accountNumber: "",
      // ifscCode: "",
      // hrNotes: "",
      role: "employee",
      permissions: ["view_own_attendance"],
    });

  } catch (error) {
    console.error("Error:", error);
    toast.error(error || "Failed");
  }
};

  // Handle reject registration
  // const handleRejectRegistration = async () => {
  //   if (!selectedEmployee) {
  //     toast.error("Please select an employee first!");
  //     return;
  //   }

  //   const reason = window.prompt("Enter rejection reason:");
  //   if (!reason) return;

  //   // You can add API call to reject with reason here
  //   // For now, just delete from pending
  //   dispatch(deletePendingRegistration(selectedEmployee._id))
  //     .then(() => {
  //       toast.error(`Registration rejected: ${reason}`);
  //     });
  // };

  // handleRejectRegistration function को ये update करें:

const handleRejectRegistration = async () => {
  if (!selectedEmployee) {
    toast.error("Please select an employee first!");
    return;
  }

  const reason = window.prompt(`Enter rejection reason for ${selectedEmployee.name}:`);
  if (!reason) return;

  try {
    await dispatch(deletePendingRegistration(selectedEmployee._id)).unwrap();
    toast.error(`Registration rejected: ${reason}`);
  } catch (error) {
    toast.error(error || "Failed to reject registration");
  }
};

  // Filter employees based on search
  const filteredEmployees = pendingEmployees.filter(emp => {
    return emp.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
           emp.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
           emp.employeeId?.toLowerCase().includes(searchTerm.toLowerCase());
  });

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="admin-register-employee">
      {/* HEADER */}
      <div className="dashboard-header">
        <div className="header-content">
          <div className="header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div>
            <h1 className="header-title">Employee Onboarding Dashboard</h1>
            <p className="header-subtitle">
              Manage pending registrations and complete employee onboarding
            </p>
          </div>
        </div>
        <div className="header-stats">
          <div className="stat-card">
            <span className="stat-count">{pendingEmployees.length}</span>
            <span className="stat-label">Pending</span>
          </div>
          <div className="stat-card">
            <span className="stat-count">{completeLoading ? "..." : "0"}</span>
            <span className="stat-label">Approved</span>
          </div>
          <div className="stat-card">
            <span className="stat-count">0</span>
            <span className="stat-label">Rejected</span>
          </div>
        </div>
      </div>

      <div className="dashboard-content">
        {/* LEFT SIDEBAR - Employee Grid */}
        <div className="employee-sidebar">
          <div className="sidebar-header">
            <h3>Pending Registrations</h3>
            <div className="search-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input
                type="text"
                placeholder="Search by name, email, or ID..."
                value={searchTerm}
                onChange={(e) => dispatch(setSearchTerm(e.target.value))}
                className="search-input"
              />
              {searchTerm && (
                <button 
                  className="clear-search"
                  onClick={() => dispatch(setSearchTerm(""))}
                >
                  ✕
                </button>
              )}
            </div>
            <button 
              className="refresh-btn"
              onClick={() => dispatch(fetchPendingOnboarding())}
              disabled={pendingLoading}
            >
              {pendingLoading ? "Refreshing..." : "🔄 Refresh"}
            </button>
          </div>

          <div className="employee-grid">
            {pendingLoading ? (
              <div className="loading-state">
                <div className="loading-spinner"></div>
                <p>Loading pending registrations...</p>
              </div>
            ) : filteredEmployees.length === 0 ? (
              <div className="empty-state">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <p>No pending registrations found</p>
                {searchTerm && <p>Try a different search term</p>}
              </div>
            ) : (
              filteredEmployees.map(employee => (
                <div
                  key={employee._id}
                  className={`employee-card ${selectedEmployee?._id === employee._id ? 'selected' : ''}`}
                  onClick={() => handleEmployeeSelect(employee)}
                >
                  <div className="employee-avatar">
                    {employee.name?.charAt(0) || "U"}
                  </div>
                  <div className="employee-info">
                    <h4>{employee.name || "Unknown"}</h4>
                    <p>{employee.email || "No email"}</p>
                    <div className="employee-meta">
                      <span>{employee.mobile || "No phone"}</span>
                      <span className="badge pending">Pending</span>
                    </div>
                  </div>
                  <div className="employee-date">
                    {formatDate(employee.createdAt)}
                  </div>
                  <div className="employee-id">
                    {employee.employeeId || "N/A"}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* MAIN CONTENT - Registration Details & HR Form */}
        <div className="main-content-section">
          {selectedEmployee ? (
            <>
              {/* User Registration Data (Auto-filled from API) */}
              <div className="section-card">
                <div className="section-header">
                  <h3>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    User Registration Details (Auto-filled)
                  </h3>
                  <span className="section-badge">Submitted by User</span>
                </div>
                
                {/* <div className="auto-filled-grid">
                  <div className="info-row">
                    <span className="info-label">Full Name:</span>
                    <span className="info-value">{selectedEmployee.name || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Email:</span>
                    <span className="info-value">{selectedEmployee.email || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Mobile:</span>
                    <span className="info-value">{selectedEmployee.mobile || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Date of Birth:</span>
                    <span className="info-value">{formatDate(selectedEmployee.birthday)}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Gender:</span>
                    <span className="info-value">{selectedEmployee.gender || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Blood Group:</span>
                    <span className="info-value">{selectedEmployee.bloodGroup || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Address:</span>
                    <span className="info-value">{selectedEmployee.address || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Employee ID:</span>
                    <span className="info-value">{selectedEmployee.employeeId || "Will be assigned"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Emergency Contact:</span>
                    <span className="info-value">
                      {selectedEmployee.emergencyContactName || "N/A"} 
                      ({selectedEmployee.emergencyContactRelation || "N/A"}) - 
                      {selectedEmployee.emergencyContactNumber || "N/A"}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">PAN Number:</span>
                    <span className="info-value">{selectedEmployee.panNumber || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Aadhaar Number:</span>
                    <span className="info-value">{selectedEmployee.aadhaarNumber || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Registration Date:</span>
                    <span className="info-value">{formatDate(selectedEmployee.createdAt)}</span>
                  </div>
                </div> */}


               

<div className="auto-filled-grid">
    <div className="info-row">
        <span className="info-label">Full Name:</span>
        <span className="info-value">{selectedEmployee.name || "N/A"}</span>
    </div>
    <div className="info-row">
        <span className="info-label">Email:</span>
        <span className="info-value">{selectedEmployee.email || "N/A"}</span>
    </div>
    <div className="info-row">
        <span className="info-label">Mobile:</span>
        <span className="info-value">
            {selectedEmployee.mobile || "Not provided"}
        </span>
    </div>
    <div className="info-row">
        <span className="info-label">Date of Birth:</span>
        <span className="info-value">
            {selectedEmployee.birthday 
                ? new Date(selectedEmployee.birthday).toLocaleDateString('en-IN')
                : "N/A"}
        </span>
    </div>
    <div className="info-row">
        <span className="info-label">Gender:</span>
        <span className="info-value">{selectedEmployee.gender || "N/A"}</span>
    </div>
    <div className="info-row">
        <span className="info-label">Blood Group:</span>
        <span className="info-value">{selectedEmployee.bloodGroup || "N/A"}</span>
    </div>
    <div className="info-row">
        <span className="info-label">Address:</span>
        <span className="info-value">{selectedEmployee.address || "N/A"}</span>
    </div>
    <div className="info-row">
        <span className="info-label">Registration Date:</span>
        <span className="info-value">
            {selectedEmployee.createdAt 
                ? new Date(selectedEmployee.createdAt).toLocaleDateString('en-IN')
                : "N/A"}
        </span>
    </div>
</div>
              </div>

              {/* HR Employment Form (To be filled by HR) */}
              <div className="section-card">
                <div className="section-header">
                  <h3>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                    Complete Employment Details (HR to fill)
                  </h3>
                  <span className="section-badge warning">Required Fields</span>
                </div>

                <div className="hr-form">
                  <div className="form-grid">
                    {/* Row 1 */}
                    <div className="input-group">
                      <label>Department *</label>
                      <select
                        name="department"
                        value={employeeForm.department}
                        onChange={handleFormChange}
                        required
                      >
                        <option value="">Select Department</option>
                        <option value="IT">IT</option>
                        <option value="Engineering">Engineering</option>
                        <option value="HR">HR</option>
                        <option value="Finance">Finance</option>
                        <option value="Sales">Sales</option>
                        <option value="Marketing">Marketing</option>
                        <option value="Support">Support</option>
                      </select>
                    </div>
                    <div className="input-group">
                      <label>Designation *</label>
                      <select
                        name="designation"
                        value={employeeForm.designation}
                        onChange={handleFormChange}
                        required
                      >
                        <option value="">Select Designation</option>
                        <option value="Software Developer">Software Developer</option>
                        <option value="Senior Developer">Senior Developer</option>
                        <option value="Team Lead">Team Lead</option>
                        <option value="Project Manager">Project Manager</option>
                        <option value="HR Executive">HR Executive</option>
                        <option value="Finance Manager">Finance Manager</option>
                        <option value="Sales Executive">Sales Executive</option>
                      </select>
                    </div>
                    <div className="input-group">
                      <label>Employee Type *</label>
                      <select
                        name="employeeType"
                        value={employeeForm.employeeType}
                        onChange={handleFormChange}
                        required
                      >
                        <option value="full-time">Full Time</option>
                        <option value="part-time">Part Time</option>
                        <option value="intern">Intern</option>
                        <option value="contract">Contract</option>
                      </select>
                    </div>
                    <div className="input-group">
                      <label>Role *</label>
                      <select
                        name="role"
                        value={employeeForm.role}
                        onChange={handleFormChange}
                        required
                      >
                        <option value="employee">Employee</option>
                        <option value="manager">Manager</option>
                        <option value="admin">Admin</option>
                        <option value="hr">HR</option>
                      </select>
                    </div>

                    {/* Row 2 */}
                    <div className="input-group">
                      <label>Date of Joining *</label>
                      <input
                        type="date"
                        name="dateOfJoining"
                        value={employeeForm.dateOfJoining}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label>Work Location</label>
                      <input
                        type="text"
                        name="workLocation"
                        value={employeeForm.workLocation}
                        onChange={handleFormChange}
                        placeholder="City, Office address"
                      />
                    </div>
                    <div className="input-group">
                      <label>Shift Timing</label>
                      <select
                        name="shiftTiming"
                        value={employeeForm.shiftTiming}
                        onChange={handleFormChange}
                      >
                        <option value="9:00 AM - 6:00 PM">9:00 AM - 6:00 PM</option>
                        <option value="10:00 AM - 7:00 PM">10:00 AM - 7:00 PM</option>
                        <option value="2:00 PM - 11:00 PM">2:00 PM - 11:00 PM</option>
                        <option value="Flexible">Flexible Hours</option>
                      </select>
                    </div>
                    <div className="input-group">
                      <label>Probation Period (months)</label>
                      <input
                        type="number"
                        name="probationPeriod"
                        value={employeeForm.probationPeriod}
                        onChange={handleFormChange}
                        min="0"
                        max="12"
                      />
                    </div>

                    {/* Row 3 - Salary */}
                     {/* <div className="input-group">
                      <label>Basic Salary (₹)</label>
                      <input
                        type="number"
                        name="basicSalary"
                        value={employeeForm.basicSalary}
                        onChange={handleFormChange}
                        placeholder="0"
                        min="0"
                      />
                    </div> */}
                    {/* <div className="input-group">
                      <label>Allowance (₹)</label>
                      <input
                        type="number"
                        name="allowance"
                        value={employeeForm.allowance}
                        onChange={handleFormChange}
                        placeholder="0"
                        min="0"
                      />
                    </div>
                    <div className="input-group">
                      <label>Deduction (₹)</label>
                      <input
                        type="number"
                        name="deduction"
                        value={employeeForm.deduction}
                        onChange={handleFormChange}
                        placeholder="0"
                        min="0"
                      />
                    </div>
                    <div className="input-group net-salary">
                      <label>Net Salary</label>
                      <div className="net-salary-display">
                        ₹ {employeeForm.netSalary ? Number(employeeForm.netSalary).toLocaleString('en-IN') : '0'}
                      </div>
                    </div>  */}

                    {/* Row 4 - Bank Details */}
                     {/* <div className="input-group">
                      <label>Bank Name</label>
                      <input
                        type="text"
                        name="bankName"
                        value={employeeForm.bankName}
                        onChange={handleFormChange}
                        placeholder="Bank name"
                      />
                    </div>
                    <div className="input-group">
                      <label>Account Number</label>
                      <input
                        type="text"
                        name="accountNumber"
                        value={employeeForm.accountNumber}
                        onChange={handleFormChange}
                        placeholder="1234567890"
                      />
                    </div>
                    <div className="input-group">
                      <label>IFSC Code</label>
                      <input
                        type="text"
                        name="ifscCode"
                        value={employeeForm.ifscCode}
                        onChange={handleFormChange}
                        placeholder="ABCD0123456"
                      />
                    </div> 
                    <div className="input-group">
                      <label>HR Notes</label>
                      <textarea
                        name="hrNotes"
                        value={employeeForm.hrNotes}
                        onChange={handleFormChange}
                        placeholder="Additional notes or comments..."
                        rows="2"
                      />
                    </div> */}
                  </div>
                </div>
              </div>

              {/* ACTION BUTTONS */}
              <div className="action-buttons">
                <button 
                  className="btn-reject"
                  onClick={handleRejectRegistration}
                  disabled={pendingLoading}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                  Reject Registration
                </button>
                <button 
                  className="btn-cancel"
                  onClick={() => dispatch(clearSelectedEmployee())}
                  disabled={completeLoading}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                  Cancel
                </button>
                <button 
                type="button"
                  className="btn-approve"
                  onClick={handleCompleteOnboarding}
                  disabled={completeLoading}
                >
                  {completeLoading ? (
                    <>
                      <span className="loading-spinner-small"></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      Approve & Complete Onboarding
                    </>
                  )}
                </button>
              </div>
            </>
          ) : (
            /* EMPTY STATE - When no employee selected */
            <div className="empty-selection">
              <div className="empty-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h3>Select an Employee</h3>
              <p>
                Click on any employee from the pending list to view their registration details 
                and complete their employment information.
              </p>
              <div className="empty-stats">
                <div className="stat">
                  <span className="stat-number">{pendingEmployees.length}</span>
                  <span className="stat-label">Pending Registrations</span>
                </div>
                <div className="stat">
                  <span className="stat-number">
                    {pendingLoading ? "..." : "0"}
                  </span>
                  <span className="stat-label">Approved Today</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
<style jsx>{`
        .admin-register-employee {
          color: white;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
          min-height: 100vh;
          background: #0f172a;
        }

        /* HEADER STYLES */
        .dashboard-header {
          background: linear-gradient(135deg, #0f172a 0%, #047857 50%, #22c55e 100%);
          padding: 20px 32px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: static;
          top: 0;
          z-index: 100;
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .header-icon {
          background: rgba(255, 255, 255, 0.1);
          padding: 12px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .header-title {
          margin: 0;
          font-size: 24px;
          font-weight: 700;
          background: linear-gradient(90deg, #fff 0%, #d1fae5 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .header-subtitle {
          margin: 4px 0 0 0;
          color: #d1fae5;
          font-size: 14px;
          opacity: 0.9;
        }

        .header-subtitle .last-checked {
          margin-left: 12px;
          font-size: 12px;
          opacity: 0.7;
        }

        .header-stats {
          display: flex;
          gap: 20px;
          align-items: center;
        }

        .stat-card {
          background: rgba(255, 255, 255, 0.1);
          padding: 12px 20px;
          border-radius: 12px;
          text-align: center;
          min-width: 100px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .stat-count {
          display: block;
          font-size: 24px;
          font-weight: 700;
          color: #ffffffff;
        }

        .stat-label {
          font-size: 12px;
          color: #d1fae5;
          opacity: 0.8;
        }

        /* REAL-TIME TOGGLE */
        .realtime-toggle {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-left: 20px;
        }

        .toggle-switch {
          position: relative;
          display: inline-block;
          width: 50px;
          height: 24px;
        }

        .toggle-switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .toggle-slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #334155;
          transition: .4s;
          border-radius: 24px;
        }

        .toggle-slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 4px;
          bottom: 4px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }

        input:checked + .toggle-slider {
          background-color: #22c55e;
        }

        input:checked + .toggle-slider:before {
          transform: translateX(26px);
        }

        .toggle-label {
          font-size: 14px;
          color: #d1fae5;
        }

        /* SUCCESS/ERROR MESSAGES */
        .success-message {
          background: rgba(34, 197, 94, 0.1);
          border: 1px solid #22c55e;
          border-radius: 8px;
          padding: 12px 20px;
          margin: 16px 32px;
          display: flex;
          align-items: center;
          gap: 10px;
          color: #22c55e;
          font-weight: 500;
        }

        .error-message {
          background: rgba(239, 68, 68, 0.1);
          border: 1px solid #ef4444;
          border-radius: 8px;
          padding: 12px 20px;
          margin: 16px 32px;
          display: flex;
          align-items: center;
          gap: 10px;
          color: #ef4444;
          font-weight: 500;
        }

        /* MAIN LAYOUT */
        .dashboard-content {
          display: flex;
          min-height: calc(100vh - 120px);
        }

        /* SIDEBAR - Employee Grid */
        .employee-sidebar {
          width: 400px;
          background: #1e293b;
          border-right: 1px solid #334155;
          overflow-y: auto;
          padding: 20px;
          position: sticky;
          top: 120px;
          height: calc(100vh - 120px);
        }

        .sidebar-header {
          margin-bottom: 20px;
        }

        .sidebar-header h3 {
          margin: 0 0 16px 0;
          color: #f8fafc;
          font-size: 18px;
          font-weight: 600;
        }

        .sidebar-controls {
          display: flex;
          gap: 12px;
          margin-bottom: 20px;
        }

        .search-box {
          position: relative;
          flex: 1;
        }

        .search-box svg {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #64748b;
        }

        .search-input {
          width: 100%;
          padding: 12px 12px 12px 40px;
          background: #0f172a;
          border: 2px solid #334155;
          border-radius: 10px;
          color: #f8fafc;
          font-size: 14px;
        }

        .search-input:focus {
          outline: none;
          border-color: #22c55e;
        }

        .refresh-btn {
          padding: 12px 16px;
          background: #0f172a;
          border: 2px solid #334155;
          border-radius: 10px;
          color: #f8fafc;
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .refresh-btn:hover {
          border-color: #22c55e;
          background: rgba(34, 197, 94, 0.1);
        }

        .refresh-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        /* EMPLOYEE GRID */
        .employee-grid {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .employee-card {
          background: #0f172a;
          border: 2px solid #334155;
          border-radius: 12px;
          padding: 16px;
          display: flex;
          align-items: center;
          gap: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }

        .employee-card:hover {
          border-color: #22c55e;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(34, 197, 94, 0.1);
        }

        .employee-card.selected {
          border-color: #22c55e;
          background: rgba(34, 197, 94, 0.05);
        }

        .employee-avatar {
          width: 48px;
          height: 48px;
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 700;
          color: white;
          flex-shrink: 0;
        }

        .employee-info {
          flex: 1;
          min-width: 0;
        }

        .employee-info h4 {
          margin: 0 0 4px 0;
          color: #f8fafc;
          font-size: 16px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .employee-info p {
          margin: 0 0 8px 0;
          color: #94a3b8;
          font-size: 13px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .employee-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .employee-meta span:first-child {
          color: #cbd5e1;
          font-size: 12px;
        }

        .badge {
          padding: 4px 8px;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 600;
        }

        .badge.pending {
          background: rgba(245, 158, 11, 0.1);
          color: #f59e0b;
          border: 1px solid rgba(245, 158, 11, 0.3);
        }

        .employee-id {
          font-size: 12px;
          color: #94a3b8;
          font-weight: 500;
        }

        .reject-icon-btn {
          background: none;
          border: none;
          color: #ef4444;
          cursor: pointer;
          padding: 4px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .reject-icon-btn:hover {
          background: rgba(239, 68, 68, 0.1);
        }

        .error-state {
          text-align: center;
          padding: 40px 20px;
          color: #ef4444;
        }

        .error-state svg {
          margin-bottom: 16px;
          color: #ef4444;
        }

        .error-state button {
          margin-top: 16px;
          padding: 8px 16px;
          background: rgba(239, 68, 68, 0.1);
          border: 1px solid #ef4444;
          color: #ef4444;
          border-radius: 6px;
          cursor: pointer;
        }

        .empty-state {
          text-align: center;
          padding: 40px 20px;
          color: #94a3b8;
        }

        .empty-state svg {
          margin-bottom: 16px;
          color: #475569;
        }

        .empty-state button {
          margin-top: 16px;
          padding: 8px 16px;
          background: #0f172a;
          border: 1px solid #334155;
          color: #f8fafc;
          border-radius: 6px;
          cursor: pointer;
        }

        /* MAIN CONTENT */
        .main-content-section {
          flex: 1;
          overflow-y: auto;
          padding: 24px;
          max-height: calc(100vh - 120px);
        }

        /* SECTION CARDS */
        .section-card {
          background: #1e293b;
          border: 1px solid #334155;
          border-radius: 16px;
          padding: 24px;
          margin-bottom: 24px;
        }

        .section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
          padding-bottom: 16px;
          border-bottom: 2px solid #334155;
        }

        .section-header h3 {
          margin: 0;
          color: #f8fafc;
          font-size: 18px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .form-actions-header {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .btn-load {
          padding: 6px 12px;
          background: rgba(59, 130, 246, 0.1);
          border: 1px solid rgba(59, 130, 246, 0.3);
          color: #3b82f6;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
        }

        .btn-load:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .section-badge {
          padding: 6px 12px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 600;
        }

        .section-badge:not(.warning) {
          background: rgba(34, 197, 94, 0.1);
          color: #22c55e;
          border: 1px solid rgba(34, 197, 94, 0.3);
        }

        .section-badge.warning {
          background: rgba(245, 158, 11, 0.1);
          color: #f59e0b;
          border: 1px solid rgba(245, 158, 11, 0.3);
        }

        /* AUTO-FILLED USER DATA */
        .auto-filled-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }

        @media (max-width: 1200px) {
          .auto-filled-grid {
            grid-template-columns: 1fr;
          }
        }

        .info-row {
          display: flex;
          padding: 12px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        }

        .info-row:last-child {
          border-bottom: none;
        }

        .info-label {
          width: 180px;
          color: #94a3b8;
          font-size: 14px;
          font-weight: 500;
        }

        .info-value {
          flex: 1;
          color: #f8fafc;
          font-size: 14px;
        }

        /* HR FORM */
        .hr-form {
          margin-top: 20px;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }

        .input-group.full-width {
          grid-column: 1 / -1;
        }

        @media (max-width: 1400px) {
          .form-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .form-grid {
            grid-template-columns: 1fr;
          }
        }

        .input-group {
          margin-bottom: 16px;
        }

        .input-group label {
          display: block;
          margin-bottom: 8px;
          color: #94a3b8;
          font-size: 14px;
          font-weight: 500;
        }

        .input-group input,
        .input-group select,
        .input-group textarea {
          width: 100%;
          padding: 12px 16px;
          background: #0f172a;
          border: 2px solid #334155;
          border-radius: 10px;
          color: #f8fafc;
          font-size: 14px;
          transition: all 0.3s ease;
        }

        .input-group input:focus,
        .input-group select:focus,
        .input-group textarea:focus {
          outline: none;
          border-color: #22c55e;
          box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
        }

        .input-group select {
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 16px center;
          cursor: pointer;
        }

        .net-salary .net-salary-display {
          padding: 12px 16px;
          background: rgba(34, 197, 94, 0.1);
          border: 2px solid #22c55e;
          border-radius: 10px;
          color: #22c55e;
          font-size: 16px;
          font-weight: 700;
          text-align: center;
        }

        /* PERMISSIONS GRID */
        .permissions-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          padding: 16px;
          background: #0f172a;
          border-radius: 10px;
          border: 2px solid #334155;
        }

        .permission-checkbox {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          color: #cbd5e1;
          cursor: pointer;
        }

        .permission-checkbox input[type="checkbox"] {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }

        /* ACTION BUTTONS */
        .action-buttons {
          display: flex;
          justify-content: flex-end;
          gap: 16px;
          padding: 24px;
          background: #1e293b;
          border-radius: 16px;
          margin-top: 24px;
        }

        .action-buttons button {
          padding: 14px 28px;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
        }

        .btn-reject {
          background: rgba(239, 68, 68, 0.1);
          color: #ef4444;
          border: 2px solid rgba(239, 68, 68, 0.3);
        }

        .btn-reject:hover {
          background: rgba(239, 68, 68, 0.2);
          transform: translateY(-2px);
        }

        .btn-save {
          background: rgba(59, 130, 246, 0.1);
          color: #3b82f6;
          border: 2px solid rgba(59, 130, 246, 0.3);
        }

        .btn-save:hover {
          background: rgba(59, 130, 246, 0.2);
          transform: translateY(-2px);
        }

        .btn-approve {
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          color: white;
        }

        .btn-approve:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(34, 197, 94, 0.3);
        }

        .btn-approve:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .loading-spinner {
          width: 16px;
          height: 16px;
          border: 2px solid #ffffff;
          border-top-color: transparent;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* EMPTY SELECTION STATE */
        .empty-selection {
          text-align: center;
          padding: 80px 40px;
        }

        .empty-icon {
          margin-bottom: 24px;
        }

        .empty-icon svg {
          color: #475569;
        }

        .empty-selection h3 {
          margin: 0 0 16px 0;
          color: #f8fafc;
          font-size: 24px;
          font-weight: 600;
        }

        .empty-selection p {
          color: #94a3b8;
          max-width: 500px;
          margin: 0 auto 40px auto;
          line-height: 1.6;
        }

        .empty-stats {
          display: flex;
          justify-content: center;
          gap: 40px;
        }

        .stat {
          text-align: center;
        }

        .stat-number {
          display: block;
          font-size: 32px;
          font-weight: 700;
          color: #22c55e;
          margin-bottom: 8px;
        }

        .stat-label {
          color: #ffffffff;
          font-size: 14px;
        }

        /* MODAL STYLES */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal-content {
          background: #1e293b;
          border: 1px solid #334155;
          border-radius: 16px;
          width: 500px;
          max-width: 90%;
          overflow: hidden;
        }

        .modal-header {
          padding: 20px 24px;
          border-bottom: 1px solid #334155;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .modal-header h3 {
          margin: 0;
          color: #f8fafc;
          font-size: 18px;
          font-weight: 600;
        }

        .modal-close {
          background: none;
          border: none;
          color: #94a3b8;
          font-size: 24px;
          cursor: pointer;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
        }

        .modal-close:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .modal-body {
          padding: 24px;
        }

        .modal-body p {
          margin: 0 0 20px 0;
          color: #cbd5e1;
          line-height: 1.5;
        }

        .modal-footer {
          padding: 20px 24px;
          border-top: 1px solid #334155;
          display: flex;
          justify-content: flex-end;
          gap: 12px;
        }

        .btn-cancel {
          padding: 10px 20px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid #334155;
          color: #f8fafc;
          border-radius: 8px;
          cursor: pointer;
        }

        .btn-confirm-reject {
          padding: 10px 20px;
          background: #ef4444;
          border: none;
          color: white;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
        }

        .btn-confirm-reject:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        /* RESPONSIVE DESIGN */
        @media (max-width: 1200px) {
          .dashboard-content {
            flex-direction: column;
          }
          
          .employee-sidebar {
            width: 100%;
            height: 300px;
            border-right: none;
            border-bottom: 1px solid #334155;
            position: static;
            top: auto;
          }
          
          .employee-grid {
            flex-direction: row;
            overflow-x: auto;
          }
          
          .employee-card {
            min-width: 300px;
          }
          
          .main-content-section {
            max-height: none;
          }
        }

        @media (max-width: 768px) {
          .dashboard-header {
            flex-direction: column;
            gap: 20px;
            text-align: center;
          }
          
          .header-stats {
            width: 100%;
            justify-content: center;
            flex-wrap: wrap;
          }
          
          .action-buttons {
            flex-direction: column;
          }
          
          .auto-filled-grid {
            grid-template-columns: 1fr;
          }
          
          .permissions-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 480px) {
          .permissions-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default AdminRegisterEmployee;

      

